<nb-card>
  <nb-card-header>
    <div class="summary">
      <div class="item">
        <div class="avatar">
          <ngx-view-user-display
            [user]="reported.author"
            [mode]="'avatar'"
          ></ngx-view-user-display>
        </div>

        <div>
          <ngx-view-user-display
            [user]="reported.author"
            [mode]="'name'"
          ></ngx-view-user-display>
          <ngx-view-time-ago
            [currentDate]="reported.createdOn"
          ></ngx-view-time-ago>

          <div>
            <button
              nbButton
              ghost
              size="tiny"
              [status]="
                reported.value <= 3
                  ? 'info'
                  : reported.value <= 6
                  ? 'warning'
                  : 'danger'
              "
            >
              <nb-icon icon="eye-off-outline"></nb-icon>
              <span> {{ reported.reason }} </span>
            </button>
          </div>

          <div class="text-link">
            <nb-icon [icon]="reported.iconMode"></nb-icon>

            <a class="link" (click)="navigateRef(reported)">
              {{
                reported.refTitle.length < 60
                  ? reported.refTitle
                  : reported.refTitle.substring(0, 60) + "..."
              }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </nb-card-header>

  <nb-card-body>
    <!-- <div class="text-heading">{{ reported.reason }}</div>
    <div class="text-hint">{{ reported.refTitle }}</div> -->

    <a
      *ngIf="reported.refId && !isMore"
      (click)="loadContent(true)"
      class="link"
    >
      <nb-icon icon="chevron-down-outline"></nb-icon>
      Xem chi tiết
    </a>

    <nb-card *ngIf="reported.refId && isMore">
      <nb-card-body *ngIf="reported.mode == 'images'">
        <ngx-view-gallery [imagesUrl]="reported.imagesUrl"> </ngx-view-gallery>
      </nb-card-body>

      <nb-card-body *ngIf="reported.mode == 'video'">
        <ngx-view-video [url]="reported.videoUrl"></ngx-view-video>
      </nb-card-body>

      <nb-card-body *ngIf="reported.mode == 'comments'">
        <ngx-view-document [content]="reported.content"> </ngx-view-document>
      </nb-card-body>
    </nb-card>

    <a
      *ngIf="reported.refId && isMore"
      (click)="loadContent(false)"
      class="link"
    >
      <nb-icon icon="chevron-up-outline"></nb-icon>
      Thu gọn
    </a>
  </nb-card-body>

  <nb-card-footer>
    <div class="button-actions">
      <ngx-view-like *ngIf="mode == 'detail'" [reported]="reported">
      </ngx-view-like>
      <button
        *ngIf="mode != 'detail'"
        nbButton
        ghost
        shape="semi-round"
        size="small"
      >
        <i class="fas fa-thumbs-up"></i>
        <span>{{ reported.noLiked | number }} </span>
      </button>

      <button nbButton ghost status="info" size="small" (click)="reply()">
        <nb-icon icon="message-square-outline"></nb-icon>

        <div *ngIf="!reported.noComment || reported.noComment == 0">
          Bình luận
        </div>

        <div *ngIf="reported.noComment > 0" style="text-transform: lowercase">
          &nbsp;Xem <span>{{ reported.noComment | number }} </span> bình luận
        </div>
      </button>
    </div>

    <div *ngIf="mode == 'admin'" class="button-actions">
      <button
        nbButton
        ghost
        status="danger"
        size="small"
        [disabled]="submitted"
        [class.btn-pulse]="submitted"
        (click)="confirm('yes', reported)"
      >
        <nb-icon icon="checkmark-square-outline"></nb-icon>
        Đúng
      </button>

      <button
        nbButton
        ghost
        status="info"
        size="small"
        [disabled]="submitted"
        [class.btn-pulse]="submitted"
        (click)="confirm('no', reported)"
      >
        <nb-icon icon="alert-triangle-outline"></nb-icon>
        Sai
      </button>

      <button
        nbButton
        ghost
        size="small"
        [disabled]="submitted"
        [class.btn-pulse]="submitted"
        (click)="confirm('hide', reported)"
      >
        <nb-icon icon="close-circle-outline"></nb-icon>
        Bỏ qua
      </button>
    </div>

    <nb-card *ngIf="view === 'replies'" class="replies">
      <nb-card-body>
        <ngx-view-comments
          [reported]="reported"
          [mode]="mode"
          (onClose)="closeReply()"
        >
        </ngx-view-comments>
      </nb-card-body>
    </nb-card>
  </nb-card-footer>
</nb-card>
